import React, { useState } from "react";
import p1 from '../assets/p1.png';
import p2 from '../assets/p2.png';
import p3 from '../assets/p3.png';
import p4 from '../assets/p4.png';
import p5 from '../assets/p5.png';
import p6 from '../assets/p6.png';

const rewards = [
  { label: "Cash Prizes", img: p1 },      
  { label: "Trophies & Medals", img: p2 },
  { label: "Certificates", img: p3 },
  { label: "Nutritious Meal", img: p4 },
  { label: "Surprise Gifts", img: p5 },
  { label: "Refreshments", img: p6 },
];

const getVisibleCount = () => {
  if (window.innerWidth < 640) return 1;
  if (window.innerWidth < 1024) return 2;
  return 5;
};

const RewardsSection = () => {
  const [startIdx, setStartIdx] = useState(0);
  const [visibleCount, setVisibleCount] = useState(getVisibleCount());

  React.useEffect(() => {
    const handleResize = () => setVisibleCount(getVisibleCount());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const maxIdx = rewards.length - visibleCount;
  const canPrev = startIdx > 0;
  const canNext = startIdx < maxIdx;

  const handlePrev = () => {
    if (canPrev) setStartIdx(startIdx - 1);
  };
  const handleNext = () => {
    if (canNext) setStartIdx(startIdx + 1);
  };

  const showButtons = rewards.length > visibleCount;

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-4xl font-extrabold text-center text-red-600 mb-4">Smash. Win. Feast.</h2>
        <p className="text-center text-lg text-gray-700 mb-12 max-w-3xl mx-auto">
          Win glory on the court and enjoy the full experience!. Cash prizes, trophies, and medals for top performers, plus certificates for all participants. Hearty non-veg meals and refreshments for every player. And keep an eye out — surprise gifts await a few lucky players!
        </p>
        <div className="flex items-center justify-center gap-4">
          {/* Desktop carousel (unchanged) */}
          <div className="hidden sm:flex items-center justify-center gap-4 w-full">
          {showButtons && (
            <button
              onClick={handlePrev}
              disabled={!canPrev}
              className="rounded-full p-2 bg-gray-200 hover:bg-gray-300 transition disabled:opacity-40 disabled:cursor-not-allowed"
              aria-label="Previous"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
              </svg>
            </button>
          )}
          <div className="flex gap-8">
            {rewards.slice(startIdx, startIdx + visibleCount).map((reward, idx) => (
              <div key={idx} className="flex flex-col items-center w-48 bg-white rounded-2xl shadow-lg p-4 flex-shrink-0">
                <div className="w-40 h-48 bg-gray-100 rounded-2xl overflow-hidden mb-4 flex items-center justify-center">
                  <img src={reward.img} alt={reward.label} className="object-cover w-full h-full" />
                </div>
                <span className="text-lg font-bold text-gray-800 text-center mt-2">{reward.label}</span>
              </div>
            ))}
          </div>
          {showButtons && (
            <button
              onClick={handleNext}
              disabled={!canNext}
              className="rounded-full p-2 bg-gray-200 hover:bg-gray-300 transition disabled:opacity-40 disabled:cursor-not-allowed"
              aria-label="Next"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </button>
          )}
          </div>
          {/* Mobile grid: 2 cards per row */}
          <div className="grid grid-cols-2 gap-4 w-full sm:hidden">
            {rewards.map((reward, idx) => (
              <div key={idx} className="flex flex-col items-center w-full bg-white rounded-2xl shadow-lg p-4">
                <div className="w-full h-32 bg-gray-100 rounded-2xl overflow-hidden mb-4 flex items-center justify-center">
                  <img src={reward.img} alt={reward.label} className="object-cover w-full h-full" />
                </div>
                <span className="text-lg font-bold text-gray-800 text-center mt-2">{reward.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default RewardsSection;
